module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_feature_rich_forums.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_feature_rich_forums.png
// module id = LaV1
// module chunks = 0